import { render } from "./ATable.vue?vue&type=template&id=144d194e&scoped=true"
import script from "./ATable.vue?vue&type=script&lang=js"
export * from "./ATable.vue?vue&type=script&lang=js"

import "./ATable.vue?vue&type=style&index=0&id=144d194e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144d194e"]])

export default __exports__